export const SUBMITTING_START = "Submitting survey response";
export const SUBMIT_COMPLETE = "Submission complete";
export const SUBMIT_FAILED = "Submission failed - please try again";
